import { useEffect, useState, useCallback } from 'react';

export const useInstallPrompt = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const updateInstalled = () => {
      setIsInstalled(
        window.matchMedia?.('(display-mode: standalone)')?.matches ||
          window.navigator.standalone === true
      );
    };

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setPromptEvent(event);
    };

    const handleInstalled = () => {
      setIsInstalled(true);
      setPromptEvent(null);
      localStorage.setItem('pwaInstallPromptDismissed', 'installed');
    };

    updateInstalled();
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!promptEvent) return { outcome: 'unavailable' };
    promptEvent.prompt();
    const choice = await promptEvent.userChoice.catch(() => ({ outcome: 'dismissed' }));
    setPromptEvent(null);
    return choice;
  }, [promptEvent]);

  return {
    canInstall: Boolean(promptEvent) && !isInstalled,
    isInstalled,
    promptInstall,
  };
};

export default useInstallPrompt;
